import { usePageCopy } from '#src/app/pages/psf/promoteOrShare/shared/hooks';

type Result = ModelHookResult<{
	heading: string;
	text: string;
}>;

export function useImpactBox(): Result {
	const {
		data: { impactBoxHeading, impactBoxMainCopy },
	} = usePageCopy();

	return {
		data: {
			heading: impactBoxHeading,
			text: impactBoxMainCopy,
		},
	};
}
